<template>
  <a-menu-item
    :key="menuInfo.key"
    v-bind="$props"
    v-on="$listeners"
    :class="{
      disabledPack: menuInfo.disabled,
    }"
  >
    <router-link v-if="menuInfo.url && !menuInfo.disabled" :to="menuInfo.url">
      <span :class="styles.title">{{ $t(menuInfo.title) }}</span>

      <i v-if="menuInfo.icon" :class="[styles.icon, menuInfo.icon]"></i>
    </router-link>
    <a @click="showUpgradeModal" v-else>
      <span :class="styles.title">{{ $t(menuInfo.title) }}</span>
      <span class="badge badge-success ml-2">Upgrade</span>
    </a>
    <span v-if="!menuInfo.url" :to="menuInfo.url">
      <span :class="styles.title">{{ $t(menuInfo.title) }}</span>
      <span v-if="menuInfo.count" class="badge badge-success ml-2">{{
        menuInfo.count
      }}</span>
      <i v-if="menuInfo.icon" :class="[styles.icon, menuInfo.icon]"></i>
    </span>
  </a-menu-item>
</template>

<script>
import { Menu } from "ant-design-vue";
import { mapMutations } from "vuex";
export default {
  name: "SubMenu",
  props: {
    ...Menu.Item.props,
    menuInfo: Object,
    styles: Object,
  },
  methods: {
    ...mapMutations("settings", ["showUpgradeModal"]),
  },
};
</script>
